import { useMemo } from "react";

type Props = {
  className?: string;
  placeholder?: string;
  onChange?: (v: string) => void;
  error?: boolean;
  disabled?: boolean;
  value?: string;
  seeThrough?: boolean;
};

export const Textarea = ({
  className,
  placeholder,
  onChange,
  error,
  disabled,
  value,
  seeThrough,
}: Props) => {
  const optionalAttributes = useMemo(() => {
    return {
      value,
      disabled,
    };
  }, [disabled, value]);

  return (
    <div className={`mb-2 flex w-full items-stretch ${className ? className : ""}`}>
      <textarea
        onChange={(e) => {
          onChange?.(e.target.value);
        }}
        className={`focus:!border-primary-border focus:shadow-primary-border-shadow grow rounded-md border border-line-color
        bg-background 
        px-3 py-2 outline-none 
        transition-all placeholder:text-text-color focus:shadow-[0_0_0_0.25rem]  
        ${error ? "!border-red !shadow-red-border-shadow !shadow-[0_0_0_0.25rem] " : ""}
        ${seeThrough ? "bg-transparent" : "bg-background"}
        `}
        placeholder={placeholder ?? ""}
        {...optionalAttributes}
      />
    </div>
  );
};
